import React from 'react';

/** Posts performance table for the Creator Dashboard. */
const PostsTable = ({ posts }) => {
  if (!posts || posts.length === 0) {
    return (
      <p
        data-testid="dashboard-posts-empty"
        className="font-serif italic text-[#90B0BF] text-lg py-8"
      >
        No posts yet. Publish your first ritual to start earning.
      </p>
    );
  }

  return (
    <div data-testid="dashboard-posts-table" className="overflow-x-auto">
      <table className="w-full text-left">
        <thead>
          <tr className="border-b border-[#C1D7E2]">
            {['Post', 'Platform', 'Views', 'Clicks', 'Shares', 'Orders', 'SEVA'].map(
              (h) => (
                <th
                  key={h}
                  className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#90B0BF] py-4 pr-6 font-medium"
                >
                  {h}
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody>
          {posts.map((p, i) => (
            <tr
              key={p.id}
              data-testid={`dashboard-post-${i}`}
              className="border-b border-[#C1D7E2]/60 hover:bg-[#C1D7E2]/15 transition-colors"
            >
              <td className="py-4 pr-6">
                <div className="flex items-center gap-3 max-w-md">
                  <img
                    src={p.media_url}
                    alt=""
                    className="w-12 h-12 object-cover border border-[#C1D7E2]"
                  />
                  <p className="text-sm text-[#7C9CB1] font-light line-clamp-2">
                    {p.caption}
                  </p>
                </div>
              </td>
              <td className="py-4 pr-6 font-mono text-[11px] uppercase tracking-[0.18em] text-[#7C9CB1]">
                {p.platform}
              </td>
              <td className="py-4 pr-6 font-mono text-sm text-[#7C9CB1]">{p.views}</td>
              <td className="py-4 pr-6 font-mono text-sm text-[#7C9CB1]">{p.clicks}</td>
              <td className="py-4 pr-6 font-mono text-sm text-[#7C9CB1]">{p.shares}</td>
              <td className="py-4 pr-6 font-mono text-sm text-[#7C9CB1]">
                {p.orders_attributed}
              </td>
              <td className="py-4 pr-6 font-mono text-sm text-[#7C9CB1]">
                {Number(p.seva_generated || 0).toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PostsTable;
